"use strict";

exports.__esModule = true;
exports.themeProviderPropTypes = void 0;

var _propTypes = require("prop-types");

var themeProviderPropTypes = {
  children: _propTypes.node,
  theme: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.object])
};
exports.themeProviderPropTypes = themeProviderPropTypes;